import { render, staticRenderFns } from "./CreateForumPostModal.vue?vue&type=template&id=c584d1de&"
import script from "./CreateForumPostModal.vue?vue&type=script&lang=js&"
export * from "./CreateForumPostModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateForumPostModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
